import { ReactNode, Ref } from 'react';

import './HorizontalScroll.css';

export default function HorizontalScroll({
  children,
  className,
  as = 'div',
  ref,
}: {
  children: ReactNode;
  className?: string;
  as?: 'div' | 'section';
  ref?: Ref<HTMLDivElement>;
}) {
  const Element = as;
  return (
    <Element className={`overflow-x-hidden ${className || ''}`}>
      <div ref={ref} className="scrollableView flex snap-x gap-3 md:gap-4">
        {children}
      </div>
    </Element>
  );
}
